import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.response.use(
  (r) => r,
  (e) => {
    if (e.response?.status === 401 && !e.config.url.includes("/auth/")) {
      if (window.location.pathname !== "/login") window.location.href = "/login";
    }
    return Promise.reject(e);
  }
);

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Une erreur est survenue";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
}

let currency = { symbole: "GNF", decimales: 0 };
export const setCurrency = (s) => {
  currency = { symbole: s?.symbole_devise || s?.devise || "GNF", decimales: Number(s?.decimales || 0) };
};

export const fmtNum = (v, dec) =>
  new Intl.NumberFormat("fr-FR", {
    minimumFractionDigits: dec ?? currency.decimales,
    maximumFractionDigits: dec ?? currency.decimales,
  }).format(Number(v || 0));

export const fmtMoney = (v) => `${fmtNum(v)} ${currency.symbole}`;
export const currencySymbol = () => currency.symbole;

export const fmtDate = (v) => {
  if (!v) return "—";
  const d = new Date(v.length === 10 ? `${v}T00:00:00` : v);
  return v.length === 10
    ? d.toLocaleDateString("fr-FR")
    : d.toLocaleString("fr-FR", { dateStyle: "short", timeStyle: "short" });
};

export const today = () => new Date().toISOString().slice(0, 10);
export const monthStart = () => today().slice(0, 8) + "01";
export const yesterday = () => new Date(Date.now() - 86400000).toISOString().slice(0, 10);

export const STATUTS = {
  brouillon: { label: "Brouillon", tone: "warning" },
  valide: { label: "Validé", tone: "success" },
  annule: { label: "Annulé", tone: "danger" },
  en_validation: { label: "En validation", tone: "info" },
  actif: { label: "Actif", tone: "success" },
  inactif: { label: "Inactif", tone: "muted" },
  suspendu: { label: "Suspendu", tone: "warning" },
  contrepasse: { label: "Contre-passé", tone: "muted" },
  contrepassation: { label: "Contre-passation", tone: "info" },
  ouverte: { label: "Ouverte", tone: "warning" },
  partielle: { label: "Partielle", tone: "info" },
  soldee: { label: "Soldée", tone: "success" },
  importee: { label: "Importée", tone: "info" },
  en_traitement: { label: "En traitement", tone: "warning" },
  cloturee: { label: "Clôturée", tone: "success" },
  complet: { label: "Complet", tone: "success" },
  partiel: { label: "Partiel", tone: "warning" },
  manquant: { label: "Manquant", tone: "danger" },
  excedent: { label: "Excédent", tone: "info" },
  validee: { label: "Validée", tone: "success" },
  annulee: { label: "Annulée", tone: "danger" },
  planifiee: { label: "Planifiée", tone: "warning" },
  en_cours: { label: "En cours", tone: "info" },
  realisee: { label: "Réalisée", tone: "success" },
  non_paye: { label: "Non payé", tone: "warning" },
  paye: { label: "Payé", tone: "success" },
  engagee: { label: "Engagée", tone: "warning" },
  approuvee: { label: "Approuvée", tone: "info" },
  partiellement_payee: { label: "Partiellement payée", tone: "info" },
  payee: { label: "Payée", tone: "success" },
  rejetee: { label: "Rejetée", tone: "danger" },
};
